import { useFetch } from '@moko/ui';
import { Stack } from '@fluentui/react';
import {
  getPricingParameters,
  type IPricingParameter,
  type IPricingParameterDefinition,
} from '../../services/pricingParameterService';
import PricingParameterLoadError from './PricingParameterLoadError';
import PricingParameterRecords from './PricingParameterRecords';
import { toRecordRows, todayUtc } from './pricingParameterHelpers';

export interface PricingParameterHistoryProps {
  definitions: IPricingParameterDefinition[];
  pricingItemId: number;
  tenantRecords: IPricingParameter[];
}

const PricingParameterHistory = ({
  definitions,
  pricingItemId,
  tenantRecords,
}: PricingParameterHistoryProps) => {
  const globalFetch = useFetch<IPricingParameter[]>({
    queryKey: ['globalPricingParameters', pricingItemId],
    queryFn: (abortController) =>
      getPricingParameters(abortController, 'global', pricingItemId),
  });
  const globalRecords = globalFetch.error ? [] : globalFetch.data ?? [];
  const rows = globalFetch.loading
    ? []
    : toRecordRows([
        ['Tenant', tenantRecords],
        ['Global', globalRecords],
      ]);

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <PricingParameterLoadError error={globalFetch.error} />
      <PricingParameterRecords
        rows={rows}
        definitions={definitions}
        loading={globalFetch.loading}
        today={todayUtc()}
        emptyTitle="No history"
        emptySubtitle="No tenant or global values exist for this pricing item."
      />
    </Stack>
  );
};

export default PricingParameterHistory;
